import { RaffleUnclaimedPrize, RaffleUnclaimedPrizeTokenData } from "views/win/userGeneratedRaffles/types";

export const parseUnclaimedPrizes = (unclaimedPrizes: RaffleUnclaimedPrize[]) => {
  return (unclaimedPrizes || [])?.reduce(
    (acc, unclaimedPrize) => {
      acc.tokens = [...acc.tokens, ...unclaimedPrize.tokens];
      if (unclaimedPrize.aggregatedETHAmount) {
        acc.ethAmount += BigInt(unclaimedPrize.aggregatedETHAmount.toString());
      }
      if (unclaimedPrize.aggregatedLOOKSAmount) {
        acc.looksAmount += BigInt(unclaimedPrize.aggregatedLOOKSAmount.toString());
      }
      return acc;
    },
    { tokens: [] as RaffleUnclaimedPrizeTokenData[], ethAmount: 0n, looksAmount: 0n }
  );
};
